module.exports = __webpack_public_path__ + "img/logo-lango.fa1f9c62.svg";